import { ITeacher } from 'models';

function normalizeCredentials(credentials: ITeacher['credentials']) {
    const experience = `experience: ${credentials.experience.split(' ')[0]}`;
    const education = credentials.education.map((ed: string) => `education: ${ed}`);

    return Object.values({ education, experience }).flat();
}

export function teacherToSpotlightWorkerApiObject(worker: ITeacher) {
    return {
        id: worker.id,
        name: worker.name,
        pictureUrl: worker.pictureUrl,
        bio: worker.bio,
        credentials: normalizeCredentials(worker.credentials),
    };
}
